import { render, staticRenderFns } from "./BulkEditorGrid.vue?vue&type=template&id=15013893&scoped=true"
import script from "./BulkEditorGrid.vue?vue&type=script&lang=js"
export * from "./BulkEditorGrid.vue?vue&type=script&lang=js"
import style0 from "./BulkEditorGrid.vue?vue&type=style&index=0&id=15013893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15013893",
  null
  
)

export default component.exports